import axios from 'axios'
import { getToken } from '../localStorage'

function getApiUrl () {
  switch (process.env.NODE_ENV) {
    case 'development':
      return 'http://localhost:3000'
    case 'staging':
      return 'https://api-staging.kimberfire.com'
    case 'production':
      return 'https://api.kimberfire.com'
    default:
      return 'http://localhost:3000'
  }
}

export const baseUrl = getApiUrl()

const agent = axios.create({ baseURL: `${baseUrl}/api` })

export const get = (url, params = {}) => makeRequest(url, 'get', params)

export const post = (url, data) => makeRequest(url, 'post', {data: data})

const getHeaders = () => ({'Authorization': `Bearer ${getToken()}`})

const makeRequest = (url, method, {data, params}) => (
  agent.request({
    headers: getHeaders(),
    url,
    method,
    data,
    params
  })
)



// WEBPACK FOOTER //
// ./src/api/index.js